import OBase from './OBase';

export default class GraftTree extends OBase {
  update () {
    let inputTree = this.getObjectInput('Tree');
    let output = this.outputs['Tree'].paramObject;

    let tree = this.graft(inputTree);
    output.value = tree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/GraftTree.js